/**
 *
 * Asynchronously loads the component for CalendarMessagesDetails
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CalendarMessagesDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.CalendarMessagesDetailsPage,
);
